import React from "react";

export const simulatorList = (lineuplist, activeList, onClick) => {
  return (
    lineuplist.map( (value) => { 
      const imgNo = value.index > 9 ? `${value.index}` : `0${value.index}` 
      const srcPath = `resource/img/static/simulator/item_${imgNo}.png`
      const isActive = activeList.findIndex(val => val.name === value.name)
      const listItemClass = isActive === -1 ? "list_item" : "list_item active"
      const quantity = isActive === -1 ? '' : activeList[isActive].quantity;
      const operator = isActive === -1 ? "plus" : "minus"
      return (
      <li className={listItemClass} onClick={() => onClick(value.name, operator, activeList)} data-quantity={quantity}>
        <img
          src={srcPath}
          className="simulator_item"
        />
        <span className="item">{value.name}</span>
      </li>
      )}
    )
  )    
}

export const footerList = (activeList, onClick) => {
  if (activeList.length === 0) {
    return (
      <div className="simulator_empty">&#9312;アイコンを選択してください。<br/>&#9313;ココに選んだアイテムが追加されます。</div>
    )
  }
  return (
    activeList.map( (value) => {
      const imgNo = value.index > 9 ? `${value.index}` : `0${value.index}`;
      const srcPath = `resource/img/static/simulator/item_${imgNo}.png`;
      return (
        <li className="list_item">
          <img
            src={srcPath}
            className="simulator_item"
          />
          <span className="item">{value.name}</span>
          <div>
            <button className="item_minus" onClick={() => onClick(value.name, "minus", activeList)}>-</button>
            <span className="item_count">{value.quantity}</span>
            <button className="item_plus"onClick={() => onClick(value.name, "plus", activeList)}>+</button>
          </div>
        </li>
      )
    })
  )
}


// WEBPACK FOOTER //
// ./common/SimulatorList.jsx